import {request} from './request'

export function register(data){
    return request({
        // 接口
        url:'/api/auth/register',
        // post的提交方法
        method:'post',
        data
    })
}

export function login(data){
    return request({
        // 接口
        url:'/api/auth/login',
        // post的提交方法
        method:'post',
        data
    })
}

export function logout(data){
    return request({
        // 接口
        url:'/api/auth/logout',
        // post的提交方法
        method:'post'
    })
}

export function getUser(){
    return request({
        // 接口
        url:'/api/user'
    })
}
